import { useSelector } from "react-redux";
import moment from "moment";
import { FILE_BASE_URL } from "configs/services/apiCollections";

export const GetTrainerToken = () => {
  const Authorization = useSelector((state) => state.auth.trainer_token);
  if (Authorization.length > 0) return Authorization;
  else return false;
};

export const GetUserToken = () => {
  const Authorization = useSelector((state) => state.auth.token);
  if (Authorization.length > 0) return Authorization;
  else return false;
};

export const getImageUrl = (imagePath, image, imageType) => {
  return FILE_BASE_URL() + imagePath + "/" + image + "." + imageType;
};

export const findAge = (birthday) => {
  const a = moment();
  const b = moment(birthday);
  if (!birthday) return 0;
  return moment.duration(a.diff(b)).years();
};

export const getPercent = (position) => {
  if (position === 0) return 60;
  else if (position === 1) return 75;
  else if (position === 2) return 100;
  else return 60;
};

export const getTargetValue = (position) => {
  if (position === 0) return "1,50 €";
  else if (position === 1) return "4,50 €";
  else if (position === 2) return "8,00 €";
  else return "0,00 €";
};

export const getRandomValue = (endValue) =>
  Math.floor(Math.random() * endValue + 1);

export const getRandomValueInRange = (startValue, endValue) =>
  Math.floor(Math.random() * (startValue - endValue + 1) + endValue);

export const isFirefox = typeof InstallTrigger !== "undefined";

export const formatToGermanCurrency = (number) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
    number
  );

export const IS_LOCAL = process.env.REACT_APP_ENV_TEMP === "local";
export const STRIPE_PUBLISHABLE_KEY = IS_LOCAL
  ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_DEV
  : process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_PROD;
